import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/custom_tags';

const model = abstractModel(resource);
const parentGet = model.get;
const parentSave = model.save;
const parentPut = model.put;
const parentDelete = model.remove;

model.get = (params = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { path: resource, filters: queryString });
    }
  }

  return parentGet(params, { path: resource });
};

model.retrieve = (tagId) => {
  return parentGet({}, { path: `${resource}/${tagId}` });
};

model.save = (data) => {
  return parentSave(data, { path: resource, csrfToken });
};

model.update = (tagId, data) => {
  return parentPut(data, { path: `${resource}/${tagId}`, csrfToken });
};

model.delete = (tagId) => {
  return parentDelete({ id: tagId }, { path: resource, csrfToken });
};

export default model;
